<template>
  <Toolbar>
    <template v-slot:start>
      <div class="toolbar-section">
        <i class="pi pi-calendar toolbar-icon ml-1"></i>
        <span class="date-connector">c</span>
        <div class="date-range">
          <CustomCalendar class="compact-calendar" dateFormat="dd.mm.yy" hideOnDateTimeSelect showTime showButtonBar
            showIcon manualInput :value="periods.dateBegin" @valueSQL="(e) => emit('update:dateBeginSQL', e)"
            @update:value="(e) => emit('update:dateBegin', e)" :disabled="Boolean(isLoadChart || isAutoUpdateChart)" />
          <span class="date-connector">по</span>
          <CustomCalendar class="compact-calendar" dateFormat="dd.mm.yy" hideOnDateTimeSelect showTime showButtonBar
            showIcon manualInput :value="periods.dateEnd" @valueSQL="(e) => emit('update:dateEndSQL', e)"
            @update:value="(e) => emit('update:dateEnd', e)" :disabled="Boolean(isLoadChart || isAutoUpdateChart)" />
        </div>
      </div>

      <div class="divider"></div>
      <div class="toolbar-section">
        <i class="pi pi-info-circle toolbar-icon" title="Режим подсказки"></i>
        <div class="setting-group">
          <div class="setting-item">
            <SelectButton :modelValue="hovermode"
              @update:modelValue="(e) => { emit('update:hovermode', e); emit('refresh'); }" :options="hoverOptions"
              optionLabel="label" optionValue="value" />
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <div class="toolbar-section">
        <i class="pi pi-pencil toolbar-icon" title="Маркер"></i>
        <div class="setting-group">
          <div class="setting-item">
            <SelectButton :modelValue="marker"
              @update:modelValue="(e) => { emit('update:marker', e); emit('refresh'); }" :options="markerOptions"
              optionLabel="label" optionValue="value" />
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <div class="toolbar-section">
        <i class="pi pi-eye toolbar-icon" title="Отображение свойств"></i>
        <div class="setting-group">
          <div class="setting-item">
            <SelectButton :modelValue="propertyAll" @update:modelValue="(e) => emit('update:propertyAll', e)"
              :options="propertyOptions" optionLabel="label" optionValue="value" />
          </div>
        </div>
      </div>

      <div class="divider"></div>
      <Button title="Обновить" label="Обновить" icon="pi pi-refresh" class="p-button-success"
        :disabled="isAutoUpdateChart || isLoadChart || isAutoUpdateChart" @click="emit('get-data')" />
      <Button title="Данные" label="Данные" icon="pi pi-database" class="p-button-success ml-1"
        :disabled="!isShowCurrentValue" @click="emit('show-data')" />
    </template>
    <template v-slot:end>
      <div class="mr-4">
        <Button :icon="isAutoUpdateChart ? 'pi pi-pause' : 'pi pi-play'"
          :label="isAutoUpdateChart ? 'Остановить' : 'Текущие значения'" :class="{
            'p-button-success': !isAutoUpdateChart,
            'p-button-danger': isAutoUpdateChart
          }" :disabled="!isShowCurrentValue" @click="emit('auto-update')" />
      </div>
    </template>
  </Toolbar>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  isLoadChart: {
    type: Boolean,
    required: true,
  },
  isAutoUpdateChart: {
    type: Boolean,
    required: true,
  },
  isShowCurrentValue: {
    type: Boolean,
    default: undefined,
  },
  periods: {
    type: Object,
    required: true,
  },
  hovermode: {
    type: String,
    required: true,
  },
  marker: {
    type: String,
    required: true,
  },
  propertyAll: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits([
  'update:dateBegin',
  'update:dateBeginSQL',
  'update:dateEnd',
  'update:dateEndSQL',
  'update:hovermode',
  'update:marker',
  'update:propertyAll',
  'refresh',
  'get-data',
  'auto-update',
  'show-data',
]);

const hoverOptions = [
  { label: 'Слитый', value: 'x unified' },
  { label: 'Раздельный', value: 'x' },
];

const markerOptions = [
  { label: 'Линия', value: 'lines' },
  { label: 'Точка', value: 'lines+markers' },
];

const propertyOptions = [
  { label: 'С признаком', value: false },
  { label: 'Все', value: true },
];
</script>

<style scoped lang="scss">
.p-toolbar {
  padding: 0.1rem;
  flex-wrap: wrap;
}

.toolbar-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.toolbar-icon {
  color: #6b7280;
  font-size: 1.1rem;
  cursor: help;
  transition: color 0.2s ease;
}

.toolbar-icon:hover {
  color: var(--primary-color);
}

.date-range {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.date-connector {
  color: #9ca3af;
  font-size: 0.9rem;
}

.compact-calendar {
  width: 140px;
}

.divider {
  width: 1px;
  height: 30px;
  background: #d1d5db;
  margin: 0 0.75rem;
}

.setting-group {
  display: flex;
  gap: 1rem;
}

.setting-item {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.setting-label {
  font-size: 0.8rem;
  color: #6b7280;
  font-weight: 500;
}
</style>